import React from 'react';
import { Trash2 } from 'lucide-react';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, title = "確定要刪除嗎？", desc = "此動作無法復原。" }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-[80] flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl p-6 max-w-sm w-full transform transition-all scale-100 border border-slate-100 dark:border-slate-700">
                <div className="w-12 h-12 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mb-4 mx-auto"><Trash2 className="w-6 h-6 text-red-500 dark:text-red-400" /></div>
                <h3 className="text-xl font-bold text-slate-800 dark:text-slate-100 text-center mb-2">{title}</h3>
                <p className="text-slate-500 dark:text-slate-400 text-center text-sm mb-6">{desc}</p>
                <div className="flex gap-3">
                    <button onClick={onClose} className="flex-1 py-2.5 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-xl font-medium hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors">取消</button>
                    <button onClick={onConfirm} className="flex-1 py-2.5 bg-red-500 text-white rounded-xl font-medium hover:bg-red-600 transition-colors shadow-lg shadow-red-200 dark:shadow-none">確認刪除</button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
